module.exports = __webpack_public_path__ + "img/contact.9c1e82f8.png";